import 'expo-dev-client'
import { StatusBar } from 'expo-status-bar';
import React, { Component } from 'react';
import { AppState, Vibration, Platform } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import * as Font from 'expo-font';
import * as Notifications from 'expo-notifications';
import UtilitiesController from './controllers/utilitiesController';
import authController from './controllers/authController';
import AnalyticsController from './controllers/analyticsController';
import { Routes as LinkRoutes } from './components';
import * as Linking from 'expo-linking';

const Router = Platform.select({
  native: () => require('react-router-native').NativeRouter,
  default: () => require('react-router-dom').BrowserRouter
})();

const Routes = Platform.select({
  native: () => require('react-router-native').Routes,
  default: () => require('react-router-dom').Routes
})();

const Route = Platform.select({
  native: () => require('react-router-native').Route,
  default: () => require('react-router-dom').Route
})();

import {
  ArticleDisplayScreen,
  WebLandingScreen,
  HomeScreen,
  LandingScreen,
  SignUpScreen,
  SignInScreen,
  ConsultationVideoAppointmentScreen,
  ConsultationStartFlowScreen,
  ConsultationChatScreen,
  ConsultationLiveVideoScreen,
  CompletedConsultationsScreen,
  PetAddScreen,
  PetDetailsScreen,
  PetListScreen,
  SettingsChangePasswordScreen,
  SettingsChangePaymentScreen,
  SettingsChangePhoneNumberScreen,
  SettingsContactSupport,
  SettingsScreen,
  SettingsUserProfileScreen,
  SettingsManageSubscriptionScreen,
  EmptyPage
} from './screens';

import AsyncStorage from '@react-native-async-storage/async-storage';

let customFonts = {
  'DMSans-Bold': require('./assets/fonts/DMSans-Bold.ttf'),
  'DMSans-BoldItalic': require('./assets/fonts/DMSans-BoldItalic.ttf'),
  'DMSans-Italic': require('./assets/fonts/DMSans-Italic.ttf'),
  'DMSans-Medium': require('./assets/fonts/DMSans-Medium.ttf'),
  'DMSans-MediumItalic': require('./assets/fonts/DMSans-MediumItalic.ttf'),
  'DMSans-Regular': require('./assets/fonts/DMSans-Regular.ttf'),
  'FontAwesome5Brands-Regular': require('./assets/fonts/FontAwesome5Brands-Regular.ttf'),
  'FontAwesome5Free-Regular': require('./assets/fonts/FontAwesome5Free-Regular.ttf'),
  'FontAwesome5Free-Solid': require('./assets/fonts/FontAwesome5Free-Solid.ttf'),
  'Lexend-SemiBold': require('./assets/fonts/Lexend-SemiBold.ttf'),
  'Lexend-Bold': require('./assets/fonts/Lexend-Bold.ttf'),
};

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: true,
    shouldSetBadge: true,
  }),
});


const Stack = createNativeStackNavigator();

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fonts_loaded: false,
      token: null,
      minute_count: 0
     }

     this._handleNotification = this._handleNotification.bind(this);
     this.render_web_routes = this.render_web_routes.bind(this);
     this.updateLoggedIn = this.updateLoggedIn.bind(this);
  }

  _loadFontsAsync = async () =>{
    await Font.loadAsync(customFonts);
    let token = await AsyncStorage.getItem('token');
    this.setState({ fonts_loaded: true, token });
  }

  _setupFBSDK = async () => {
    if (Platform.OS !== "web") {
      const FBSDK = require("react-native-fbsdk-next");
      const { Settings, AppEventsLogger } = FBSDK;

      Settings.initializeSDK();

      AppEventsLogger.logEvent(AppEventsLogger.AppEvents.CompletedRegistration, {
        [AppEventsLogger.AppEventParams.RegistrationMethod]: "email",
      })
      AppEventsLogger.flush() // Using flush to see the events in realtime on the FB dashboard
    }
  }

  _onEveryMinute = async () => {
    let current_min_count = this.state.minute_count;
    let new_min_count     = current_min_count + 1;

    if (new_min_count % 5 === 0) {
      await AnalyticsController.updateSessionLatestPing({});
    }

    this.setState({ minute_count: new_min_count })
  }

  componentWillUnmount() {
    clearInterval(this.timer_ref);
  }

  async componentDidMount() {

    await authController.v3Test();
    await authController.v4Test();

    this.timer_ref = setInterval(this._onEveryMinute, 60000);

    let app_url = Linking.createURL();
    let token   = await AsyncStorage.getItem('token');

    this.setState({ isLoggedIn: !!token })
    this._setupFBSDK();
    this._loadFontsAsync();

    await AnalyticsController.updateMobileSession({ start_state: 'LAUNCHED' });

    // Wire up notification handler
    Notifications.addNotificationResponseReceivedListener( this._handleNotification );

    AppState.addEventListener('change', async (nextAppState)=> {

      this._handleNotification();

      let user_id = await AsyncStorage.getItem('user_id');

      if(user_id) {
        this.socket = UtilitiesController.getSocket({query: `room_id=${user_id}`, name: "app_socket"})
      }

      if(nextAppState == 'active') {
        await AnalyticsController.updateMobileSession({ start_state: 'REOPENED' });
      }

      if(nextAppState == 'background') {
        await AnalyticsController.updateMobileSession({ has_ended: true });
      }

      if(nextAppState == 'active') {

        await authController.v3Test();
        await authController.v4Test();

        // update database to mark if user is on the app
        if(user_id && this.socket) {
          this.socket.emit("user_connection", { connected: true });
        }

        if(Platform.OS === 'ios') {
          Notifications.setBadgeCountAsync(0);
        };

      } else {
        // update database to mark if user is on the app
        if(user_id && this.socket && (nextAppState === 'background' || nextAppState === 'inactive')) {
          this.socket.emit("user_connection", { connected: false });
        }
      }
    });
  }

  async _handleNotification(data) {
    try {
      let push_link;
      let notification_data = {};

      if(data && data.notification && data.notification.request && data.notification.request.content && data.notification.request.content.data && data.notification.request.content.data.push_link) {
        push_link = data.notification.request.content.data.push_link;
      }

      if(data && data.notification && data.notification.request && data.notification.request.content && data.notification.request.content.data && data.notification.request.content.data) {
        notification_data = data.notification.request.content.data;
      }

      //push_link = '/article/5047826';

      if(push_link) {
        this.setState({fonts_loaded: false}, async () => {
          console.log('getting to get link')
         // await AsyncStorage.setItem('link_params', JSON.stringify(params))
          await AsyncStorage.setItem('link_route', push_link);

          this.setState({fonts_loaded: true, push_link, notification_data: notification_data });
        })
      } else {
        this.setState({fonts_loaded: true, notification_data: notification_data });
      }

    } catch(err) {
      console.log('err', err)
    }
  }

  updateLoggedIn(isLoggedIn) {
    let is_logged_in = isLoggedIn === true ? true : false;
      this.setState({
        isLoggedIn: is_logged_in
      })
  }

  render_web_routes(isLoggedIn) {

    return <Router>
              <Routes>
                  {true || isLoggedIn ?
                    <>
                      <Route path={ `*` } element={<HomeScreen onSignIn={this.updateLoggedIn} onSignOut={this.updateLoggedIn}/>} />
                      <Route path={ LinkRoutes.PET_DETAILS } element={<PetDetailsScreen/>} />
                      <Route path={ LinkRoutes.ARTICLE_DISPLAY } element={<ArticleDisplayScreen/>} />
                      <Route path={ `${LinkRoutes.HOME}` } element={<HomeScreen onSignIn={this.updateLoggedIn} onSignOut={this.updateLoggedIn}/>}  />
                      <Route path={`${LinkRoutes.WEB_LANDING}`}  element={<WebLandingScreen />} />
                      <Route path={ LinkRoutes.PET_DETAILS } element={<PetDetailsScreen/>} />
                      <Route path={ LinkRoutes.CONSULTATIONS_COMPLETED } element={<CompletedConsultationsScreen/>} />
                      <Route path={ LinkRoutes.PET_ADD }                 element={<PetAddScreen/>} options={{ presentation: 'modal' }} />
                      <Route path={ LinkRoutes.CONSULTATION_START_FLOW } element={<ConsultationStartFlowScreen/>} />
                      <Route path={ LinkRoutes.CONSULTATION_VIDEO_APPOINTMENT } element={<ConsultationVideoAppointmentScreen/>} />
                      <Route path={ LinkRoutes.CONSULTATION_CHAT } element={<ConsultationChatScreen/>} />
                      <Route path={ LinkRoutes.CONSULTATION_LIVE_VIDEO } element={<ConsultationLiveVideoScreen/>} />
                      <Route path={ LinkRoutes.PET_LIST }                 element={<PetListScreen/>} />
                      <Route path={ LinkRoutes.SETTINGS_CHANGE_PASSWORD } element={<SettingsChangePasswordScreen/>} />
                      <Route path={ LinkRoutes.SETTINGS_CHANGE_PAYMENT }  element={<SettingsChangePaymentScreen/>} />
                      <Route path={ LinkRoutes.SETTINGS_CHANGE_PHONE_NUMBER } element={<SettingsChangePhoneNumberScreen/>} />
                      <Route path={ LinkRoutes.SETTINGS_CONTACT_SUPPORT }     element={<SettingsContactSupport/>} />
                      <Route path={ LinkRoutes.SETTINGS }                     element={<SettingsScreen onSignOut={this.updateLoggedIn}/>} />
                      <Route path={ LinkRoutes.SETTINGS_USER_PROFILE }        element={<SettingsUserProfileScreen/>} />
                      <Route path={ LinkRoutes.SETTINGS_MANAGE_SUBSCRIPTION } element={<SettingsManageSubscriptionScreen/>} />
                      <Route path={ `${LinkRoutes.SIGN_UP}` } element={<SignUpScreen onSignIn={this.updateLoggedIn}/>}  />
                      <Route path={ `${LinkRoutes.SIGN_IN}` } element={<SignInScreen onSignIn={this.updateLoggedIn}/>}  />
                      <Route path={ `${LinkRoutes.EMPTY_PAGE}` } element={<EmptyPage />}  />
                    </> :
                    <>
                      <Route path={ `*` } element={<LandingScreen/>} />
                      <Route path={ `${LinkRoutes.HOME}` } element={<HomeScreen onSignIn={this.updateLoggedIn}/>} onSignOut={this.updateLoggedIn}  />
                      <Route path={`${LinkRoutes.WEB_LANDING}`}  element={<WebLandingScreen />} />
                      <Route path={ `${LinkRoutes.LANDING}` } element={<LandingScreen/>} />
                      <Route path={ `${LinkRoutes.SIGN_UP}` } element={<SignUpScreen onSignIn={this.updateLoggedIn}/>}  />
                      <Route path={ `${LinkRoutes.SIGN_IN}` } element={<SignInScreen onSignIn={this.updateLoggedIn}/>}  />
                      <Route path={ `${LinkRoutes.EMPTY_PAGE}` } element={<EmptyPage />}  />
                    </>}
              </Routes>
            </Router>
  }

  render_native_routes(isLoggedIn) {
    let initialRoute = LinkRoutes.LANDING;

    if(isLoggedIn) {
      initialRoute = LinkRoutes.HOME;
    }

    initialRoute = LinkRoutes.HOME;

    return <NavigationContainer>
            <Stack.Navigator initialRouteName={ initialRoute }
                            screenOptions={{
                              headerShown: false
                            }}>

              <Stack.Screen name={LinkRoutes.HOME}>
                {props => <HomeScreen {...props} push_link={this.state.push_link} notification_data={this.state.notification_data} clear_notification_data={ () => { this.setState({ notification_data: {} }) }} onSignOut={this.updateLoggedIn} />}
              </Stack.Screen>

              <Stack.Screen name={ LinkRoutes.LANDING } component={LandingScreen} />

              <Stack.Screen name={LinkRoutes.SIGN_UP}>
                {props => <SignUpScreen {...props} onSignIn={this.updateLoggedIn} />}
              </Stack.Screen>

              <Stack.Screen name={LinkRoutes.SIGN_IN}>
                {props => <SignInScreen {...props} onSignIn={this.updateLoggedIn} />}
              </Stack.Screen>

              <Stack.Screen name={ LinkRoutes.PET_DETAILS } component={PetDetailsScreen} />
              <Stack.Screen name={ LinkRoutes.CONSULTATIONS_COMPLETED } component={CompletedConsultationsScreen} />
              <Stack.Screen name={ LinkRoutes.PET_ADD }                 component={PetAddScreen} options={{ presentation: 'modal' }} />
              <Stack.Screen name={ LinkRoutes.CONSULTATION_START_FLOW } component={ConsultationStartFlowScreen} />
              <Stack.Screen name={ LinkRoutes.ARTICLE_DISPLAY }         component={ArticleDisplayScreen} />

              <Stack.Screen name={LinkRoutes.CONSULTATION_VIDEO_APPOINTMENT}>
                {props => <ConsultationVideoAppointmentScreen {...props}/>}
              </Stack.Screen>

              <Stack.Screen name={ LinkRoutes.CONSULTATION_CHAT } component={ConsultationChatScreen} />
              <Stack.Screen name={ LinkRoutes.CONSULTATION_LIVE_VIDEO }  component={ConsultationLiveVideoScreen} />
              <Stack.Screen name={ LinkRoutes.PET_LIST }                 component={PetListScreen} />
              <Stack.Screen name={ LinkRoutes.SETTINGS_CHANGE_PASSWORD } component={SettingsChangePasswordScreen} />
              <Stack.Screen name={ LinkRoutes.SETTINGS_CHANGE_PAYMENT }  component={SettingsChangePaymentScreen} />
              <Stack.Screen name={ LinkRoutes.SETTINGS_CHANGE_PHONE_NUMBER } component={SettingsChangePhoneNumberScreen} />
              <Stack.Screen name={ LinkRoutes.SETTINGS_CONTACT_SUPPORT }     component={SettingsContactSupport} />
              <Stack.Screen name={ LinkRoutes.SETTINGS_MANAGE_SUBSCRIPTION } component={SettingsManageSubscriptionScreen} />

              <Stack.Screen name={LinkRoutes.SETTINGS}>
                {props => <SettingsScreen {...props} onSignOut={this.updateLoggedIn} />}
              </Stack.Screen>

              <Stack.Screen name={ LinkRoutes.SETTINGS_USER_PROFILE }        component={SettingsUserProfileScreen} />

            </Stack.Navigator>
          </NavigationContainer>
  }

  render() {
    let isLoggedIn = this.state.isLoggedIn;
    let is_web = Platform.OS === 'web';

    return (
      this.state.fonts_loaded  ? (is_web ? this.render_web_routes(isLoggedIn) : this.render_native_routes(isLoggedIn)) : null
    );
  }
}

export default App;
